import { Component } from '@angular/core';
import { CrudService } from 'src/app/services/crud.service';
import { environment } from 'src/environments/environment';
import { NotifyService } from 'src/app/services/notify.service';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { DxDataGridModule, DxBoxModule, DxLookupModule, DxButtonModule, DxTextAreaModule, DxLoadPanelModule } from 'devextreme-angular';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
  selector: 'app-promotion-export',
  templateUrl: './promotion-export.component.html',
  styleUrl: './promotion-export.component.css',
  standalone: true,
  imports: [DxDataGridModule, DxBoxModule, DxLookupModule, DxButtonModule, DxTextAreaModule, DxLoadPanelModule, PageHeaderComponent]
})
export class PromotionExportComponent {
  dataSource: any;
  promotionPeriods: any;
  promotionPeriodId: number = 0;
  detailsLoading: boolean = false;
  private apiUrl: string = environment.baseApiUrl;

  constructor(private crudService: CrudService, private notify: NotifyService) {
    // Initialize any necessary data or services
    this.loadData();
  }

  loadData()  {
    this.detailsLoading = true;
    this.crudService.getData(`${this.apiUrl}promotion-periods`).subscribe((data: any) => {
      this.promotionPeriods = data;
      this.detailsLoading = false;
    });
  }

  getPromotionExportData() {
    // Logic to load data for promotion export
    if(this.promotionPeriodId === 0) {
      this.notify.returnError('Please select a Buying Group and Promotion and Warehouse');
      return;
    }
    
    this.detailsLoading = true;
    
    this.crudService.getData(`${this.apiUrl}promotion-export/${this.promotionPeriodId}`).subscribe({
      next: (data: any) => {
        this.dataSource = data;
        this.detailsLoading = false;
      },
      error: (error: any) => {
        this.detailsLoading = false;
        
        let errorMessage = 'Failed to load promotion export data.';
        
        // Handle the specific error structure from API
        if (error?.error?.message) {
          errorMessage = error.error.message;
          
          // Add period IDs if available for multiple EDLP periods
          if (error.error.data?.found_period_ids) {
            const periodIds = error.error.data.found_period_ids.join(', ');
            errorMessage += ` Found period IDs: ${periodIds}`;
          }
        } else if (error?.message) {
          errorMessage = error.message;
        }
        
        this.notify.returnError(errorMessage);
      }
    });
  }

  setPromotionPeriodId(e: any) {
    this.promotionPeriodId = e.value;
  }

  getPromotionPeriodName(): string {
    const selectedPeriod = this.promotionPeriods.find((period: any) => period.id === this.promotionPeriodId);
    return selectedPeriod ? selectedPeriod.promotion_name : '';
  }

  sanitizeSheetName(name: string): string {
      return name.replace(/[:\\/?*\[\]]/g, '_');
    }

    onExporting(e: any) {
      const selectedPeriodName = this.getPromotionPeriodName();
      console.log("Selected Promotion Period Name:", selectedPeriodName);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(this.sanitizeSheetName(selectedPeriodName));

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
        customizeCell: ({ gridCell, excelCell }) => {
          if(gridCell?.rowType === 'header') {
            excelCell.font = { bold: true };
            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '6ABDC8' } };
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Promotion_Export ${this.sanitizeSheetName(selectedPeriodName)}.xlsx`);
        });
      });
    }

    customizeColumns(e: any) {
      e.forEach((column: any) => {
        column.caption = column.dataField;
      });
    }

}
